export const CONSTANTS = {
  AccountingReport: 'Звіт для бухгалтерії',
  AllRefuels: 'Усі заправки',
  ChoosePeriod: 'Обрати період:',
  Print: 'Друк',
  DieselSell: 'Продаж дизеля',
  FuelWriteOffTitle: 'Пальне до списання (наші авто)',

  TABLE_HEADER_ITEMS: [
    {
      key: 'dateTime',
      label: 'Дата',
      sortable: true,
    },
    { key: 'driver', label: 'Картка' },
    { key: 'liters', label: 'Літри' },
    { key: 'amount_uah', label: 'Сума (грн.)' },
    { key: 'azs', label: 'АЗС' },
    // { key: 'azs', label: 'АЗС', selectable: true },
    { key: 'comment', label: 'Коментар' },
  ],
};
